/* unplugin-vue-components disabled */import { render } from "./standardappmap.vue?vue&type=template&id=99c035ea&scoped=true"
import script from "./standardappmap.vue?vue&type=script&lang=js"
export * from "./standardappmap.vue?vue&type=script&lang=js"

import "./standardappmap.vue?vue&type=style&index=0&id=99c035ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99c035ea"]])

export default __exports__